export default import.meta.ROLLDOWN_FILE_URL_VpDiOm53i8o_O8vYp_y8kA